import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import App from '@/App';
import ResourceManage from '@/pages/advanced/ResourceManage';
import RuleEngine from '@/pages/advanced/RuleEngine';
import SceneLinkage from '@/pages/advanced/SceneLinkage';
import LinkageLog from '@/pages/advanced/SceneLinkage/LinkageLog';
import Login from '@/pages/auth/login/index';
import MyService from '@/pages/cloud/MyService';
import ServiceMarket from '@/pages/cloud/Service';
import DataHistory from '@/pages/data/History';
import Documents from '@/pages/documents/Documents';
import Drive from '@/pages/drive';
import DeviceGroup from '@/pages/gateway/DeviceGroup';
import DeviceManage from '@/pages/gateway/DeviceManage';
import DeviceDetail from '@/pages/gateway/DeviceManage/Detail';
import DriveImage from '@/pages/gateway/DriveImage';
import DeviceMap from '@/pages/gateway/Map';
import MyDrive from '@/pages/gateway/MyDrive';
import ProductManage from '@/pages/gateway/ProductManage';
import ProductDetail from '@/pages/gateway/ProductManage/Detail';
import ProductTemplate from '@/pages/gateway/ProductTemplate';
import DataScreen from '@/pages/goview';
import Dashboard from '@/pages/home/Dashboard';
import AlarmCenter from '@/pages/monitor/AlarmCenter';
import RuleDetail from '@/pages/monitor/AlarmCenter/Detail';
import SystemMonitor from '@/pages/monitor/SystemMonitor';
import Dept from '@/pages/system/Dept';
import Log from '@/pages/system/Log';
import Menu from '@/pages/system/Menu';
import Role from '@/pages/system/Role';
import SysSet from '@/pages/system/Set';
import User from '@/pages/system/User';
import UserProfile from '@/pages/system/UserProfile';
import VideoDevice from '@/pages/video/device';
import VideoPlayback from '@/pages/video/playback';
import VideoScreen from '@/pages/video/screen';
import WorkOrderList from '@/pages/workorder';
import WorkOrderDetail from '@/pages/workorder/Detail';
import CustomerDevicePage from '@/pages/customer';
import ProviderDevicePage from '@/pages/provider';
import CustomerProviderPage from '@/pages/customerProvider';
import FilterPricePage from '@/pages/filterPrice';
import { Empty } from 'antd';

const router = createBrowserRouter([
  {
    path: '/auth/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/:type/service',
        element: <ServiceMarket />,
      },
      {
        path: '/:type/my/service',
        element: <MyService />,
      },
      {
        path: '/gateway/product/manage',
        element: <ProductManage />,
      },
      {
        path: '/gateway/product/detail/:id',
        element: <ProductDetail />,
      },
      {
        path: '/gateway/product/template',
        element: <ProductTemplate />,
      },
      {
        path: '/:type/device/manage',
        element: <DeviceManage />,
      },
      {
        path: '/:type/device/map',
        element: <DeviceMap />,
      },
      {
        path: '/gateway/device/manage/:id',
        element: <DeviceManage />,
      },
      {
        path: '/gateway/device/detail/:id',
        element: <DeviceDetail />,
      },
      {
        path: '/gateway/device/group',
        element: <DeviceGroup />,
      },
      {
        path: '/:type/drive/image',
        element: <DriveImage />,
      },
      {
        path: '/:type/my/drive',
        element: <MyDrive />,
      },
      {
        path: '/home/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/:type/alarmCenter/list',
        element: <AlarmCenter />,
      },
      {
        path: '/:type/systemMonitor',
        element: <SystemMonitor />,
      },
      {
        path: '/monitor/alarmCenter/detail/:id',
        element: <RuleDetail />,
      },
      {
        path: '/advanced/resource/manage',
        element: <ResourceManage />,
      },
      {
        path: '/advanced/rule/engine',
        element: <RuleEngine />,
      },
      {
        path: '/:type/scene/linkage',
        element: <SceneLinkage />,
      },
      {
        path: '/advanced/scene/log/:id',
        element: <LinkageLog />,
      },
      {
        path: '/documents/documents',
        element: <Documents />,
      },
      {
        path: '/admin/sysDept',
        element: <Dept />,
      },
      {
        path: '/admin/sysMenu',
        element: <Menu />,
      },
      {
        path: '/admin/sysRole',
        element: <Role />,
      },
      {
        path: '/admin/sysUser',
        element: <User />,
      },
      {
        path: '/admin/sysLoginLog',
        element: <Log />,
      },
      {
        path: '/admin/sysSet',
        element: <SysSet />,
      },
      {
        path: '/common/userProfile',
        element: <UserProfile />,
      },
      {
        path: '/video/record/playback',
        element: <VideoPlayback />,
      },
      {
        path: '/video/screen/display',
        element: <VideoScreen />,
      },
      {
        path: '/video/device',
        element: <VideoDevice />,
      },
      {
        path: '/data/history',
        element: <DataHistory />,
      },
      {
        path: '/goview',
        element: <DataScreen />,
      },
      {
        path: '/driver/overview',
        element: <Drive />,
      },
      {
        path: '/driver/image',
        element: <DriveImage />,
      },
      {
        path: '/driver/my',
        element: <MyDrive />,
      },
      {
        path: '/workorder/list',
        element: <WorkOrderList />,
      },
      {
        path: '/workorder/detail/:id',
        element: <WorkOrderDetail />,
      },
      {
        path: '/device-bind/customer-device',
        element: <CustomerDevicePage />,
      },
      {
        path: '/device-bind/provider-device',
        element: <ProviderDevicePage />,
      },
      {
        path: '/device-bind/customer-provider',
        element: <CustomerProviderPage />,
      },
      {
        path: '/workorder/filter-price',
        element: <FilterPricePage />,
      },
    ],
  },
  {
    path: '*',
    element: <Empty description={'404 Not Found'} style={{ marginTop: '300px' }} />,
  },
]);

export default router;
